<template>
  <div>
    <QrScanner ref="qrScanner"></QrScanner>
    <div ref="modal" class="modal">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">{{ $t("AddTag") }}</p>
        </header>
        <section class="modal-card-body">
            <div class="card">
                <div class="card-content">
                    <template v-if="step == 1">
                        <div class="field">
                            <div class="control has-icons-left has-icons-right">
                                <input ref="nfcId" v-model="nfcId" @click="hideTabs()" @focus="hideTabs()" @blur="showTabs()" class="input" type="text" autocomplete="off" :placeholder="$t('TagID')" pattern="[A-Fa-f0-9]{8}" maxlength="8" required>
                                <span class="icon is-small is-left">
                                    <i class="fa fa-tag"></i>
                                </span>
                                <span @click="scanQr()" :title="$t('ClickToScanQrCode')" class="icon clickable is-small is-right">
                                    <i class="fa fa-qrcode"></i>
                                </span>
                            </div>
                        </div>
                    </template>
                    <template v-if="step == 2">
                        <div class="field">
                            <div class="control has-icons-left">
                                <input v-model="nfcId" class="input" type="text" autocomplete="off" :placeholder="$t('TagID')" pattern="[A-Fa-f0-9]{8}" maxlength="8" required disabled readonly>
                                <span class="icon is-small is-left">
                                    <i class="fa fa-tag"></i>
                                </span>
                            </div>
                        </div>
                        <!-- <div class="field">
                            <div class="control has-icons-left">
                                <input ref="tagName" v-model="name" @click="hideTabs()" @focus="hideTabs()" @blur="showTabs()" class="input" type="text" autocomplete="off" :placeholder="$t('TagName')" required>
                                <span class="icon is-small is-left">
                                    <i class="fa fa-tag"></i>
                                </span>
                            </div>
                        </div> -->
                        <div class="columns is-mobile is-centered">
                            <div class="column">
                                <div class="control has-icons-left">
                                    <div class="select is-fullwidth">
                                        <select ref="callingCode" v-model="callingCode">
                                            <option disabled value="disabled">{{ $t("Country") }}</option>
                                            <option v-for="country in countries" :key="country.id" :value="country.callingCode">{{ country.name }} (+{{ country.callingCode }})</option>
                                        </select>
                                    </div>
                                    <div class="icon is-small is-left">
                                        <i class="fa fa-globe"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="column">
                                <div class="field">
                                    <div class="control has-icons-left">
                                        <input ref="mobile" v-model="mobile" @click="hideTabs()" @focus="hideTabs()" @blur="showTabs()" class="input no-spinner" autocomplete="off" type="number" :placeholder="$t('Mobile')" min="0">
                                        <span class="icon is-small is-left">
                                            <i class="fa fa-phone"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="!mobile" class="column is-mobile is-centered">
                            <span><i class="fa fa-exclamation-circle"></i> Phone number should be registered if available. Leave blank if user has no phone</span>
                        </div>
                    </template>
                </div>
            </div>
        </section>
        <footer class="modal-card-foot has-text-centered">
            <template v-if="step == 1">
                <a @click="next()" class="button is-primary is-fullwidth">
                    <span class="icon">
                        <i class="fa fa-arrow-right"></i>
                    </span>
                    <span>{{ $t("Next") }}</span>
                </a>
                <a @click="cancel()" class="button is-info is-fullwidth">
                    <span class="icon">
                        <i class="fa fa-times"></i>
                    </span>
                    <span>{{ $t("Cancel") }}</span>
                </a>
            </template>
            <template v-if="step == 2">
                <a @click="add()" class="button is-primary is-fullwidth">
                    <span class="icon">
                        <i class="fa fa-plus-circle"></i>
                    </span>
                    <span>{{ $t("Add") }}</span>
                </a>
                
                <a @click="back()" class="button is-info is-fullwidth">
                    <span class="icon">
                        <i class="fa fa-arrow-left"></i>
                    </span>
                    <span>{{ $t("Back") }}</span>
                </a>
            </template>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import QrScanner from "@/components/QrScanner.vue";

export default {
  name: "AddTag",
  components: {
    QrScanner
  },
  props:
  {
    _callingCode: String,
    _mobile: String,
  },
  data() {
    return {
      step: 1,
      nfcId: null,
      name: null,
      callingCode: null,
      mobile: null
    }
  },
  methods:
  {
    start: function()
    {
        if(this._callingCode)
        {
            this.callingCode = this._callingCode;
            this.mobile = this._mobile;
        }

        this.$refs.modal.classList.add("is-active");
    },
    cancel: function()
    {
        this.step = 1;
        this.nfcId = null;
        this.name = null;
        this.$refs.modal.classList.remove("is-active");
    },
    add: function()
    {
        if (this.$refs.callingCode.selectedIndex == 0) {
            this.$refs.callingCode.selectedIndex = -1;
        }

        if(!this.$refs.callingCode.checkValidity())
        {
            this.$refs.callingCode.reportValidity();
            return;
        }

        if(!this.$refs.mobile.checkValidity())
        {
            this.$refs.mobile.reportValidity();
            return;
        }

        if(this.$parent.addTag)
        {
            this.$parent.addTag(
            {
                nfcid: this.nfcId,
                name: this.name,
                callingCode: this.callingCode == "disabled" ? null : this.callingCode,
                credits: 0,
                mobile: this.mobile,
                removable: true
            })
        }
        
        this.cancel();
    },
    back: function() {
      this.step = 1;
    },
    next: async function() {
    
    if(!this.$refs.nfcId.checkValidity())
    {
        this.$refs.nfcId.reportValidity();
        return;
    }

    const response = await this.$http.get(`/Tags/Available/${this.nfcId.toUpperCase()}`);  

    if(!response.data.tag.available)
    {
        alert(this.$t("TagAlreadyRegistered"));
        return;
    }
    
    if(response.data.tag.name)
    {
        this.tagName = response.data.tag.name;
    }

    if(response.data.tag.callingCode)
    {
        this.callingCode = response.data.tag.callingCode;
    }

    if(response.data.tag.mobile)
    {
        this.mobile = response.data.tag.mobile;
    }

    if(this.$parent.household && !Object.keys(this.$parent.household).length)
    {
        this.$parent.household =
        {
            id: response.data.tag.householdID,
            name: response.data.tag.householdName,
            numberOfPeople: response.data.tag.numberOfPeople || 1,
            address: response.data.tag.address,
            systemID: response.data.tag.waterSystemID || "disabled",
            assetID: response.data.tag.assetID || "disabled",
            tags: []
        }
    }

    if(this.$parent.updateTaps)
    {
        this.$parent.updateTaps();
    }
      
      this.step = 2;
      
    },
    scanQr: function() {
        this.$refs.qrScanner.scanQr();
    },
    qrResult: function(result) {
        const pattern = /^[A-Fa-f0-9]{8}$/;

        if (!pattern.test(result))
        {
            alert(this.$t("ErrorQrCodeDoesntContainATagId"));
            return;
        }

        this.nfcId = result;
      }
  }
};
</script>